import { Component, OnInit } from '@angular/core';
import { ParamMap } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { ItemInfo } from 'src/app/models/models';
import { Category, Item, Item_Points } from 'src/app/models/RestModels';
import { RestResponse, SearchObject } from 'src/app/services/Rest';
import { BaseComponent } from '../base/base.component';
import { ItemNamePipe } from "../../pipes/item-name.pipe";
import { ShortDatePipe } from "../../pipes/short-date.pipe";

interface CItemPoints{
	item_points: Item_Points;
	item_info:ItemInfo;
	item: Item;
	category: Category | null;
};

@Component
({
	selector: 'app-list-item-points',
	templateUrl: './list-item-points.component.html',
	styleUrls: ['./list-item-points.component.css'],
})
export class ListItemPointsComponent extends BaseComponent implements OnInit
{

	item_points_list: CItemPoints[] = [];
    item_points_search: SearchObject<Item_Points>;

	ngOnInit(): void
	{
		this.sink = this.route.paramMap.pipe
		(
			mergeMap((params)=>
			{
				this.item_points_search = this.getSearch(params,['item_id','id','type','qty']);
				//this.rest.item_points.search( this.item_points_search);
				return this.rest.item_points.search( this.item_points_search );
			}),
			mergeMap((response)=>
			{
				let item_ids:number[] = response.data.map((item_points)=>item_points.item_id);

				return forkJoin
				({
					item_points: of(response),
					item_info: this.rest.item_info.search({csv:{id:item_ids}, limit:99999})
				})
			}),
			mergeMap((response)=>
			{
				let x:CItemPoints[] = response
				.item_points.data
				.map((item_points:Item_Points)=>
				{
					let find_func = (i:ItemInfo)=>i.item.id == item_points.item_id
					let item_info:ItemInfo = response.item_info.data.find( find_func ) as ItemInfo;

					return {
						item_points: item_points,
						item_info: item_info,
						item: item_info.item,
						category: item_info.category
					};
				});

				return of( x );
			})
		)
		.subscribe
		({
			next: (response) =>
			{
				this.item_points_list = response;
				this.is_loading = false;
			},
			error: (error) =>
			{
				this.showError(error);
			}
		})
	}
	deleteItemPoint(ci: CItemPoints)
	{
		this.subs.sink = this.confirmation.showConfirmAlert
		(
			ci,
			'Eliminar registro de puntos',
			'Esta seguro de querer eliminar el registro de puntos'
		)
		.pipe
		(
			filter(x=>x.accepted),
			mergeMap((x)=>
			{
				this.is_loading = true;
				let ci:CItemPoints = x.obj as CItemPoints;
				return this.rest.item_points.delete( ci.item_points );
			})
		)
		.subscribe
		({
			next:(response)=>
			{
				let index = this.item_points_list.findIndex( x => x==ci );
				if( index < 0 )
					return;

				this.item_points_list.splice(index,1);
				this.is_loading = false;
			}
			,error:(error)=>
			{
				this.showError(error);
			}
		})
	}
}
